import { render, staticRenderFns } from "./automation.vue?vue&type=template&id=8242fdc4&scoped=true"
import script from "./automation.vue?vue&type=script&lang=js"
export * from "./automation.vue?vue&type=script&lang=js"
import style0 from "./automation.vue?vue&type=style&index=0&id=8242fdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8242fdc4",
  null
  
)

export default component.exports